import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 bg-white p-8 rounded-2xl shadow-xl">
        <h1 className="font-heading text-2xl font-bold text-navy">Lupa Kata Sandi</h1>
        {done ? (
          <p className="text-sm text-slate-600" data-testid="forgot-done">Jika email terdaftar, tautan reset telah dikirim. Silakan cek email Anda.</p>
        ) : (
          <>
            <p className="text-sm text-muted-foreground">Masukkan email Anda untuk menerima tautan reset.</p>
            {error && <div className="text-sm text-primary">{error}</div>}
            <div className="space-y-1.5">
              <Label>Email</Label>
              <Input type="email" data-testid="forgot-email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <Button type="submit" data-testid="forgot-submit" className="w-full bg-primary hover:bg-red-700">Kirim Tautan Reset</Button>
          </>
        )}
        <div className="text-center">
          <Link to="/login" className="text-xs text-muted-foreground hover:text-primary">Kembali ke Masuk</Link>
        </div>
      </form>
    </div>
  );
}
